<script setup>
import { useAuthStore } from '@/stores'

const props = defineProps({
  company: { 
    required: true, 
    type: [Object, null],
    default: {} 
  },
  target: {
    type: String,
    default: null,
  },
})

const { currentUser } = useAuthStore()

</script>

<template lang="pug">
template(v-if="currentUser.isManager")
  RouterLink.text-link(
    :to="{ name: 'companyShow', params: { companyId: company.id } }"
    :target="props.target"
  ) {{ company.name }}
template(v-else) {{ company.name }}
</template>